const EWKB_FLAG_Z = 0x80000000;
const EWKB_FLAG_M = 0x40000000;
const EWKB_FLAG_SRID = 0x20000000;
const MAX_SRID = 10000;
export let WKBGeometryType = function (WKBGeometryType) {
  WKBGeometryType[WKBGeometryType["Point"] = 1] = "Point";
  WKBGeometryType[WKBGeometryType["LineString"] = 2] = "LineString";
  WKBGeometryType[WKBGeometryType["Polygon"] = 3] = "Polygon";
  WKBGeometryType[WKBGeometryType["MultiPoint"] = 4] = "MultiPoint";
  WKBGeometryType[WKBGeometryType["MultiLineString"] = 5] = "MultiLineString";
  WKBGeometryType[WKBGeometryType["MultiPolygon"] = 6] = "MultiPolygon";
  WKBGeometryType[WKBGeometryType["GeometryCollection"] = 7] = "GeometryCollection";
  return WKBGeometryType;
}({});
export function isWKB(arrayBuffer) {
  const dataView = new DataView(arrayBuffer);
  let byteOffset = 0;
  const endianness = dataView.getUint8(byteOffset);
  byteOffset += 1;
  if (endianness > 1) {
    return false;
  }
  const littleEndian = endianness === 1;
  const geometry = dataView.getUint32(byteOffset, littleEndian);
  byteOffset += 4;
  const geometryType = geometry & 0x07;
  if (geometryType === 0 || geometryType > 7) {
    return false;
  }
  const geometryFlags = geometry - geometryType;
  if (geometryFlags === 0 || geometryFlags === 1000 || geometryFlags === 2000 || geometryFlags === 3000) {
    return true;
  }
  if ((geometryFlags & ~(EWKB_FLAG_Z | EWKB_FLAG_M | EWKB_FLAG_SRID)) !== 0) {
    return false;
  }
  if (geometryFlags & EWKB_FLAG_SRID) {
    const srid = dataView.getUint32(byteOffset, littleEndian);
    byteOffset += 4;
    if (srid > MAX_SRID) {
      return false;
    }
  }
  return true;
}
export function parseWKBHeader(dataView, target) {
  const wkbHeader = Object.assign(target || {}, {
    type: 'wkb',
    geometryType: 1,
    dimensions: 2,
    coordinates: 'xy',
    littleEndian: true,
    byteOffset: 0
  });
  wkbHeader.littleEndian = dataView.getUint8(wkbHeader.byteOffset) === 1;
  wkbHeader.byteOffset++;
  const geometryCode = dataView.getUint32(wkbHeader.byteOffset, wkbHeader.littleEndian);
  wkbHeader.byteOffset += 4;
  wkbHeader.geometryType = geometryCode & 0x7;
  const isoType = (geometryCode - wkbHeader.geometryType) / 1000;
  switch (isoType) {
    case 0:
      break;
    case 1:
      wkbHeader.type = 'iso-wkb';
      wkbHeader.dimensions = 3;
      wkbHeader.coordinates = 'xyz';
      break;
    case 2:
      wkbHeader.type = 'iso-wkb';
      wkbHeader.dimensions = 3;
      wkbHeader.coordinates = 'xym';
      break;
    case 3:
      wkbHeader.type = 'iso-wkb';
      wkbHeader.dimensions = 4;
      wkbHeader.coordinates = 'xyzm';
      break;
    default:
      throw new Error(`WKB: Unsupported iso-wkb type: ${isoType}`);
  }
  const ewkbZ = geometryCode & EWKB_FLAG_Z;
  const ewkbM = geometryCode & EWKB_FLAG_M;
  const ewkbSRID = geometryCode & EWKB_FLAG_SRID;
  if (ewkbZ && ewkbM) {
    wkbHeader.type = 'ewkb';
    wkbHeader.dimensions = 4;
    wkbHeader.coordinates = 'xyzm';
  } else if (ewkbZ) {
    wkbHeader.type = 'ewkb';
    wkbHeader.dimensions = 3;
    wkbHeader.coordinates = 'xyz';
  } else if (ewkbM) {
    wkbHeader.type = 'ewkb';
    wkbHeader.dimensions = 3;
    wkbHeader.coordinates = 'xym';
  }
  if (ewkbSRID) {
    wkbHeader.type = 'ewkb';
    wkbHeader.srid = dataView.getUint32(wkbHeader.byteOffset, wkbHeader.littleEndian);
    wkbHeader.byteOffset += 4;
  }
  return wkbHeader;
}
//# sourceMappingURL=parse-wkb-header.js.map